import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread"; //@ts-check

import React from 'react';
import Grid from '@material-ui/core/Grid';
import Icon from '../../../core/Icon';
import FilterExpressionFieldFormInput from './FilterExpressionField';
import FilterExpressionOperatorFormInput from './FilterExpressionOperator';
import FilterExpressionValueFormInput from './FilterExpressionValue';
import { useFilterContext, getFieldSchema, getFieldSchemaOperators, getFieldSchemaDefaultValue } from './FilterContext';

var useCallbacks = function useCallbacks(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      onDelete = _ref.onDelete,
      expIdx = _ref.expIdx;
  var valueRef = React.useRef(null);
  var fieldRef = React.useRef(null);

  var _useFilterContext = useFilterContext(),
      schema = _useFilterContext.schema;

  var on = React.useMemo(function () {
    var context = {
      expIdx: expIdx
    };

    var change = function change(newValue) {
      return onChange(_objectSpread({}, value, newValue), context);
    };

    var fieldChange = function fieldChange(newField) {
      if (newField !== value.Field) {
        var fieldSchema = getFieldSchema(schema, newField);
        var newOps = getFieldSchemaOperators(fieldSchema);
        var newOp = value.Op;
        if (newOps.length && newOps.indexOf(newOp) === -1) newOp = newOps[0];
        var newValue = getFieldSchemaDefaultValue(fieldSchema);
        if (fieldRef.current) fieldRef.current.blur();
        setTimeout(function () {
          var ref = null;
          if (valueRef.current) ref = valueRef.current;
          if (ref) ref.focus();
        }, 100);
        return change({
          Field: newField,
          Op: newOp,
          Value: newValue
        });
      } else {
        if (fieldRef.current) fieldRef.current.blur();
      }
    };

    var opChange = function opChange(newOp) {
      return change({
        Op: newOp
      });
    };

    var valueChange = function valueChange(newValue) {
      return change({
        Value: newValue
      });
    };

    var remove = function remove() {
      return onDelete(context);
    };

    return {
      fieldChange: fieldChange,
      opChange: opChange,
      valueChange: valueChange,
      remove: remove
    };
  }, [value, onChange, onDelete, expIdx]);
  return {
    on: on,
    refs: {
      field: fieldRef,
      value: valueRef
    }
  };
};
/**
 * @param {import('./types').FormInputFilterExpressionProps } props
 */


var FilterExpressionFormInput = function FilterExpressionFormInput(_ref2) {
  var value = _ref2.value,
      onChange = _ref2.onChange,
      onDelete = _ref2.onDelete,
      expIdx = _ref2.expIdx;

  var _useCallbacks = useCallbacks({
    value: value,
    onChange: onChange,
    onDelete: onDelete,
    expIdx: expIdx
  }),
      on = _useCallbacks.on,
      refs = _useCallbacks.refs;

  return React.createElement(Grid, {
    container: true,
    spacing: 2,
    alignContent: "center"
  }, React.createElement(Grid, {
    item: true,
    xs: 4
  }, React.createElement(FilterExpressionFieldFormInput, {
    value: value.Field,
    onChange: on.fieldChange,
    field: value.Field,
    ref: refs.field
  })), React.createElement(Grid, {
    item: true,
    xs: 2
  }, React.createElement(FilterExpressionOperatorFormInput, {
    value: value.Op,
    onChange: on.opChange,
    field: value.Field
  })), React.createElement(Grid, {
    item: true,
    xs: 5
  }, React.createElement(FilterExpressionValueFormInput, {
    value: value.Value,
    onChange: on.valueChange,
    field: value.Field,
    ref: refs.value
  })), React.createElement(Grid, {
    item: true,
    xs: 1
  }, React.createElement("div", {
    style: {
      opacity: 0.3
    }
  }, React.createElement(Icon, {
    type: "close",
    label: "Remove",
    hoverable: "opacity",
    onClick: on.remove
  }))));
};

FilterExpressionFormInput.defaultProps = {};
export default React.memo(FilterExpressionFormInput);